<template>
  <div class="service-block" style="margin-bottom: 25px">
    <div class="service-block__img">
      <div class="service-block__img-block">
        <p class="service-block__img-text service-block__img-text--mobile" v-html="$t('sn-registration.registerToolsTextMob')"></p>
        <p class="service-block__img-text" v-html="$t('sn-registration.registerToolsText')"></p>
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(image, i) in slideImages" :key="i" class="service-block__slider">
            <div class="service-block__slide">
              <img
                class="swiper-lazy"
                :src="image"
                :alt="'Серійний номер на інструменті' + (i + 1)"
              />
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
        <p class="service-block__img-text service-block__img-text--small" v-html="$t('sn-registration.registerWarrantyText')"></p>
      </div>
    </div>
    <div class="service-block__form">
      <div class="service-block__form-wrap" v-if="!isLoadUserInfo">
        <template v-if="!isUserAuth && placement !== 'cabinet'">
          <p class="service-block__form-title" v-html="$t('sn-registration.authTitle')"></p>
          <auth-form is-ajax-auth></auth-form>
        </template>
        <tools-registration-form v-else></tools-registration-form>
      </div>
      <custom-loader v-else is-loading></custom-loader>
    </div>
    <notifications group="error" position="top center" :max="3"></notifications>
    <notifications group="success" position="top center" :max="3"></notifications>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import ToolsRegistrationForm from '@/components/forms/ToolsRegistrationForm'
import AuthForm from '@/components/auth/AuthForm'
import CustomLoader from '@/components/helpers/Loader'

export default {
  name: 'ToolsRegistration',
  components: {
    AuthForm,
    ToolsRegistrationForm,
    Swiper,
    SwiperSlide,
    CustomLoader
  },
  props: {
    placement: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    ...mapState({
      userFromServer: state => state.user
    }),
    isLoadUserInfo () {
      if (this.userFromServer) {
        return this.userFromServer.isContactFormLoading
      }
      return false
    },
    isUserAuth () {
      return this.userFromServer?.auth
    },
    slideImages () {
      return [1, 2, 3, 4, 5].map((i) => `/img/tool-reg-img/${i}.jpg`)
    }
  }
}
</script>

<style scoped lang="sass">
.service-block__form
  position: relative

.service-block__form-wrap
  margin: 0 auto

  +mmin($tablet)
    padding: 0 15px

  +mmin($tablet--hor)
    width: 70%

::v-deep
  .swiper-pagination
    position: static

  .swiper-pagination-bullet
    background: $text-color
    opacity: .4

    &:not(:last-child)
      margin-right: 5px

      +mmin($tablet--hor)
        margin-right: 10px

  .swiper-pagination-bullet-active
    opacity: 1

</style>
